var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI_icon_lock_light",
    "data-name": "UI icon/lock/light",
    transform: "translate(-4 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M3,3.732a2,2,0,1,0-2,0V5A1,1,0,0,0,3,5Z",
    transform: "translate(10 12)",
    fill: "#6f767e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union-2",
    "data-name": "Union",
    d: "M13,20H3a3,3,0,0,1-3-3V9A3,3,0,0,1,3,6V5A5,5,0,1,1,13,5V6a3,3,0,0,1,3,3v8A3,3,0,0,1,13,20ZM3,8A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1ZM8,2A3,3,0,0,0,5,5V6h6V5A3,3,0,0,0,8,2Z",
    transform: "translate(4 2)",
    fill: "#6f767e"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassIcon);
export default __webpack_public_path__ + "static/media/pass-icon.8d6b3b5e462d71d90724b906877f09ec.svg";
export { ForwardRef as ReactComponent };